import { useRef } from 'react'

import {
  EMPTY_FUNCTION,
  EMPTY_LIST,
  EMPTY_OBJECT,
} from '../../../constants/common'
import { setRef } from '../../../utils/react'
import { EMAIL_FORM_CONTEXT_DEFAULT_VALUE } from '../Email.constants'
import { EmailFormContext } from '../EmailForm.context'

function EmailCreationFormProvider({
  blackList = EMPTY_OBJECT,
  children,
  externalRef,
  getIsDirty,
  setBlackList = EMPTY_FUNCTION,
  ...restProps
}) {
  // to have access to formik context
  const innerRef = useRef(null)

  function setInnerRef(node) {
    setRef(externalRef, node)
    innerRef.current = node
  }

  const value = {
    ...EMAIL_FORM_CONTEXT_DEFAULT_VALUE,
    ...restProps,
    blackList: blackList || EMPTY_LIST,
    getIsDirty,
    innerRef,
    setBlackList,
    setInnerRef,
  }

  return <EmailFormContext value={value}>{children}</EmailFormContext>
}

export default EmailCreationFormProvider
